var map = {
	"./1.png": "nYED",
	"./2.png": "XaML",
	"./3.png": "k0u4",
	"./4.png": "AOVd",
	"./5.png": "2d/n",
	"./6.png": "xchJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "U/09";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon ^\.\/.*\.png$
// module id = U/09
// module chunks = 0